import { render, staticRenderFns } from "./grccms_topmenu.vue?vue&type=template&id=722ad855&scoped=true&"
import script from "./grccms_topmenu.vue?vue&type=script&lang=js&"
export * from "./grccms_topmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ad855",
  null
  
)

export default component.exports